export class ConnectorError extends Error {}
